import getAeConfig from './configs/aeConfig';
import getCsmConfig from './configs/csmConfig';
import getSdrConfig from './configs/sdrConfig';
import getVpConfig from './configs/vpConfig';
import { JobsInquiryPosition } from '@/types/graphql';
import type { JobsSectionModels } from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export const getProfileConfig = ({ inquiry, user }: JobsSectionModels) => {
  if (inquiry.positionOther) {
    return getSdrConfig({ inquiry, user });
  }

  switch (inquiry.positionMain) {
    case JobsInquiryPosition.AccountExecutive:
      return getAeConfig({ inquiry, user });
    case JobsInquiryPosition.Sdr:
      return getSdrConfig({ inquiry, user });
    case JobsInquiryPosition.Csm:
      return getCsmConfig({ inquiry, user });
    case JobsInquiryPosition.Vp:
      return getVpConfig({ inquiry, user });
    default:
      return getSdrConfig({ inquiry, user });
  }
};
